export default __webpack_public_path__ + "static/media/hekma.9dd91749.png";